export enum MissionId {
  WN_1 = 'wn_1',
  WN_2 = 'wn_2',
  WN_3 = 'wn_3',
  WN_4 = 'wn_4',
  WN_5 = 'wn_5',
  WN_6 = 'wn_6',
  WN_7 = 'wn_7',
  WN_8 = 'wn_8',
  WN_9 = 'wn_9',
  WN_10 = 'wn_10',
  WN_11 = 'wn_11',
  WN_12 = 'wn_12',
  WN_13 = 'wn_13',
  WN_14 = 'wn_14',
  WN_15 = 'wn_15',
  WN_16 = 'wn_16',
  WN_17 = 'wn_17',
  WN_18 = 'wn_18',
  WN_19 = 'wn_19',
  WN_20 = 'wn_20',
}

export enum MissionStatus {
  DEFAULT = 0,
  ACTIVE = 1,
  DONE = 2,
}

export enum MissionRewardType {
  CP = 'cp',
  FREE_SPINS = 'free_spins',
  CASH_BONUS = 'cash_bonus',
}
